// paxsudos/frontend/patch-status-counters.js
// Forces counters to show on all StatusList usages by default.

function enableCounters(mod) {
  const C = (mod && (mod.default || mod));
  if (C) {
    C.defaultProps = Object.assign({}, C.defaultProps, { withCounters: true });
    return true;
  }
  return false;
}

let ok = false;
try { ok = enableCounters(require('mastodon/components/status_list')) || ok; } catch {}
try { ok = enableCounters(require('@/mastodon/components/status_list')) || ok; } catch {}
// Silently continue even if not found at import time; other code paths may import it later.
